import React from 'react';

import { baseStyles } from '../styles';
import { Ai2Layout } from '../../ai2/layout/Ai2Layout';

function NoAccess(): React.ReactElement {
  return (
    <div style={baseStyles.app}>
      <div style={baseStyles.centeredContainer}>
        <h3>Unable to access dashboard</h3>
        <br></br>
        <div>
          <p>
            The CareMappr dashboard is only available to clinicians at opted in
            clinics.
          </p>
          <p>
            Please contact your supervisor or the CareMappr support team if you
            should have access.
          </p>
        </div>
      </div>
    </div>
  );
}

function NoAccessPatient(): React.ReactElement {
  return (
    <Ai2Layout>
      <div className="ui offsetNavbar">
        <div style={baseStyles.app}>
          <div style={baseStyles.centeredContainer}>
            <h3>Unable to access patient data</h3>
            <br></br>
            <div>
              <p>
                Your profile or organisation doesnt have access to this patients
                data.
              </p>
              <p>
                Please contact your supervisor or the CareMappr support team if
                you should have access to this patient.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Ai2Layout>
  );
}

export { NoAccess, NoAccessPatient };
